import { useState } from "react";
import { Link } from "react-router-dom";
import { ref, update } from "firebase/database";
import { database } from "../constants/firebase";
import { useUser } from "../contexts/UserContext";
import { rows, useRecord } from "../utils/appData";
import WorkShell, { State } from "../components/AppPage";
export default function AdminApprovals() {
  const { currentUser } = useUser();
  const jobs = useRecord(currentUser?.isAdmin ? "Jobs" : null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(null);
  const pending = rows(jobs.data).filter((j) => j.approvalStatus === "pending");
  async function decide(j, status) {
    const reason =
      status === "rejected"
        ? window.prompt("Reason for rejecting this job:")
        : "";
    if (reason === null) return;
    setBusy(j.id);
    setError("");
    try {
      await update(ref(database, `Jobs/${j.id}`), {
        approvalStatus: status,
        rejectionReason: reason || null,
        reviewedAt: Date.now(),
        reviewedBy: currentUser.uid,
      });
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(null);
    }
  }
  return (
    <WorkShell
      title="Job approvals"
      subtitle="New accounts are automatically approved."
    >
      <State {...jobs} error={error || jobs.error} empty={!pending.length}>
        There are no jobs awaiting review.
      </State>
      {pending.map((j) => (
        <article
          key={j.id}
          className="zy-card mb-[18px] rounded-[20px] border border-slate-200 bg-white p-[22px] dark:border-[#363e46] dark:bg-[#23272c] [&_h2]:mb-3 [&_h2]:text-[19px] [&_h2]:font-bold [&_h3]:mb-2 [&_h3]:text-[17px] [&_h3]:font-bold"
        >
          <Link
            className="zy-link font-semibold text-[#327691] dark:text-[#5FAFCB]"
            to={`/jobs/${j.id}`}
          >
            <h2>{j.title}</h2>
          </Link>
          <p>{j.description}</p>
          <p className="zy-muted text-sm text-slate-500 dark:text-[#a4b0bc] my-4">
            {j.hostName} · {j.location} · {j.payRate}
          </p>
          <div className="zy-actions flex flex-wrap items-center gap-3">
            <button
              className="zy-button inline-flex min-h-11 cursor-pointer items-center justify-center gap-2 rounded-[14px] px-[17px] py-[11px] text-sm font-semibold disabled:cursor-wait disabled:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#49a3c9] border border-slate-200 bg-white dark:border-[#363e46] dark:bg-[#23272c] secondary"
              disabled={Boolean(busy)}
              onClick={() => decide(j, "rejected")}
            >
              Reject
            </button>
            <button
              className="zy-button inline-flex min-h-11 cursor-pointer items-center justify-center gap-2 rounded-[14px] px-[17px] py-[11px] text-sm font-semibold disabled:cursor-wait disabled:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#49a3c9] bg-[#327691] text-white"
              disabled={Boolean(busy)}
              onClick={() => decide(j, "approved")}
            >
              {busy === j.id ? "Saving…" : "Approve"}
            </button>
          </div>
        </article>
      ))}
    </WorkShell>
  );
}
